import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import SalesForceTable from '../../../../components/tables/SalesForceTable';

const TSM = () => {
  // Sample data generator
  const generateSampleData = (count = 50) => {
    const states = [
      'Maharashtra', 'Delhi', 'Karnataka', 'Tamil Nadu', 'Gujarat',
      'Rajasthan', 'Uttar Pradesh', 'West Bengal', 'Telangana', 'Punjab',
      'Haryana', 'Kerala', 'Madhya Pradesh', 'Andhra Pradesh', 'Bihar',
      'Odisha', 'Jharkhand', 'Chhattisgarh', 'Assam', 'Goa'
    ];
    const names = [
      'Vivek Sharma', 'Anjali Nair', 'Karthik Reddy', 'Megha Patel',
      'Rohit Joshi', 'Shweta Agarwal', 'Ashish Kumar', 'Pallavi Singh',
      'Manish Gupta', 'Nidhi Malhotra', 'Gaurav Bansal', 'Preeti Saxena',
      'Vikrant Yadav', 'Deepika Sharma', 'Harish Verma', 'Sakshi Jain',
      'Mohit Tiwari', 'Pooja Kulkarni', 'Naveen Rao', 'Richa Bhardwaj',
      'Sandeep Das', 'Kritika Menon', 'Pankaj Dubey', 'Anita Desai',
      'Sunil Pandey', 'Madhuri Iyer', 'Ajay Khanna', 'Snehal Patil'
    ];
    
    return Array.from({ length: count }, (_, i) => ({
      id: `TSM${String(i + 1).padStart(4, '0')}`,
      name: names[Math.floor(Math.random() * names.length)],
      mobile: `+91 ${Math.floor(Math.random() * 9000000000) + 1000000000}`,
      state: states[Math.floor(Math.random() * states.length)],
      date: new Date(2022 + Math.floor(Math.random() * 3), Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1)
        .toISOString().split('T')[0]
    }));
  };

  // Initialize data with state
  const [salesData, setSalesData] = useState({
    data: generateSampleData(50)
  });

  // Handle data change (add/edit)
  const handleDataChange = (newData) => {
    setSalesData({
      data: newData
    });
  };

  return (
    <Container fluid className="">
      <SalesForceTable
        data={salesData.data}
        salesRole="Sale Representative"
        onDataChange={handleDataChange}
      />
    </Container>
  );
};

export default TSM;

